import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faRightLeft } from '@fortawesome/free-solid-svg-icons';
import { useProfile } from '../../context/ProfileContext';
import './ProfileBanner.css';

const ProfileBanner: React.FC = () => {
  const { activeProfile, isViewingAsOther, showProfileSwitcher } = useProfile();

  if (!isViewingAsOther || !activeProfile) {
    return null;
  }

  return (
    <div className="profile-banner" role="status" aria-live="polite">
      <FontAwesomeIcon icon={faEye} className="profile-banner-icon" />
      <span className="profile-banner-text">
        Viewing as{' '}
        <span className="profile-banner-name">{activeProfile.name}</span>
        {activeProfile.relationship && (
          <span className="profile-banner-relationship">
            {' '}({activeProfile.relationship})
          </span>
        )}
      </span>
      <button
        className="profile-banner-switch"
        onClick={showProfileSwitcher}
        aria-label="Switch to a different profile"
      >
        <FontAwesomeIcon icon={faRightLeft} />
        Switch Profile
      </button>
    </div>
  );
};

export default ProfileBanner;
